import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getAll() {
        try
        {            
            const response = await axios.get(`CompanyAnnouncements`,
            {
                headers: {
                    'page_key': pageKeys.company_announcements
                }
            })               
            return response
        }
        catch (error)
        {
            console.log('CompanyAnnouncements api getAll error')
            throw error
        }
    },
    async getCategories() {
        try
        {            
            const response = await axios.get(`CompanyAnnouncements/categories`,
            {
                headers: {
                    'page_key': pageKeys.company_announcements
                }
            })              
            return response
        }
        catch (error)
        {
            console.log('CompanyAnnouncements api getCategories error')
            throw error
        }
    },
    async upsert(data) {
        try
        {            
            const response = await axios.post(`CompanyAnnouncements`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.company_announcements
                }
            })      
            return response
        }
        catch (error)
        {
            console.log('CompanyAnnouncements api upsert error')
            throw error
        }
    },
    async getNowShowing() {
        try
        {            
            //used in MyDasboard
            const response = await axios.get(`CompanyAnnouncements/now-showing`)              
            return response
        }
        catch (error)
        {
            console.log('CompanyAnnouncements api getNowShowing error')
            throw error
        }
    },
}